import { Injectable } from '@angular/core';
import {ApiService} from './api.service';
import {map} from 'rxjs/operators';
import {BehaviorSubject, Observable} from 'rxjs';
import {Event, EventRestaurant} from '../restaurant-manager.models';

@Injectable({
  providedIn: 'root'
})
export class EventService {

  selectedEvent: BehaviorSubject<Event> = new BehaviorSubject<Event>(null);

  constructor(private apiService: ApiService) {
    this.selectedEvent.next(EventService.getFromLocalStorage());
  }

  static getFromLocalStorage(): Event {
    const event = JSON.parse(localStorage.getItem('selected_event'));
    return event ? new Event(event) : null;
  }

  save(): void {
    localStorage.setItem('selected_event', JSON.stringify(this.selectedEvent.value));
  }

  list(): Observable<Event[]> {
    return this.apiService.get<Event[]>('/events', false).pipe(map((result: Event[]) => {
      const events: Event[] = result.map(r => new Event(r));
      if (events.length > 0) {
        if (this.selectedEvent.value) {
          const event = events.find(e => e.id === EventService.getFromLocalStorage().id);
          if (event) {
            this.selectEvent(event);
          } else {
            this.selectEvent(null);
          }
        }
      }
      return events;
    }));
  }

  selectEvent(event: Event): void {
    this.selectedEvent.next(event);
    this.save();
  }

  getEventRestaurantByRestaurantId(id: string): EventRestaurant {
    return this.selectedEvent.value.eventRestaurants.find(r => r.restaurant.id === id);
  }

}
